export type PortalAuthPortal = 'hire' | 'seek' | 'admin';

const INTERNAL_AUTH_DOMAIN = 'auth.fork.internal';

export function normalizeVisibleEmail(email: string) {
  return email.trim().toLowerCase();
}

function base64UrlEncode(value: string) {
  const bytes = new TextEncoder().encode(value);
  let binary = '';

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
}

export function getPortalAuthEmail(portal: PortalAuthPortal, visibleEmail: string) {
  const normalizedEmail = normalizeVisibleEmail(visibleEmail);
  return `${portal}.${base64UrlEncode(normalizedEmail)}@${INTERNAL_AUTH_DOMAIN}`.toLowerCase();
}

export function isPortalAuthNamespacingEnabled() {
  return import.meta.env.DEV && import.meta.env.VITE_ENABLE_PORTAL_AUTH_NAMESPACING === 'true';
}
